import { css } from 'aphrodite';
import { hashHistory } from 'react-router';
import * as React from 'react';
import autobind from 'autobind-decorator';

import * as accountRequestAPI from 'login-apis/accountRequestAPI';
import * as routerState from 'login-utils/routerState';
import OldChoosePasswordForm, {
  CORE_PASSWORD_PROPERTY,
} from 'login-components/ChoosePasswordForm/OldChoosePasswordForm';
import FormDialog from 'login-components/Common/Form/FormDialog/FormDialog';
import States from 'login-constants/states';

import './LenderActivationOld.scss';
import { submitLenderActivationRequest } from './activationUtils';
import Activation from './Activation';
import activationStyles from './activationStyles';

@autobind
class LenderActivationOld extends React.Component<{}, {}> {
  async submitActivationRequest(formValues) {
    const valuesToSubmit = {
      password: formValues[CORE_PASSWORD_PROPERTY],
    };

    const { data } = await submitLenderActivationRequest(valuesToSubmit);
    routerState.set('success', data as string);
    hashHistory.push(States.LOGIN);
  }

  validateActivation() {
    return accountRequestAPI.validate('activation');
  }

  render() {
    return (
      <div className="LenderActivation">
        <div className={css(activationStyles.activation)}>
          <Activation validateActivation={this.validateActivation}>
            <FormDialog>
              <OldChoosePasswordForm submitPassword={this.submitActivationRequest} />
            </FormDialog>
          </Activation>
        </div>
      </div>
    );
  }
}

export default LenderActivationOld;
